module.exports = __webpack_public_path__ + "img/machinery cloud system diagram.71be0d57.png";